import type { WorkBook } from 'xlsx';

import {
  scanCatalogWorkbook,
  type CatalogSheetRow,
  type CatalogWorklistBuckets,
} from './catalogWorklist';
import type { FlagReason, FlaggedVendorItemListRow } from './types';

export const VENDOR_ITEM_LIST_HEADERS = ['SUNAME', 'CATEGORY3'] as const;

export type VendorItemListAnalysis =
  CatalogWorklistBuckets<FlaggedVendorItemListRow>;

function pipeReasons(english: string, french: string): FlagReason[] {
  const reasons: FlagReason[] = [];
  if (english.includes('|')) {
    reasons.push({
      id: 'pipeInDescription',
      column: 'ENGLISH DESCRIPTION',
      value: english,
    });
  }
  if (french.includes('|')) {
    reasons.push({
      id: 'pipeInDescription',
      column: 'FRENCH DESCRIPTION',
      value: french,
    });
  }
  return reasons;
}

function toFlaggedVendorItemList(
  input: CatalogSheetRow,
): FlaggedVendorItemListRow {
  const englishDescription = input.cell('ENGLISH DESCRIPTION');
  const frenchDescription = input.cell('FRENCH DESCRIPTION');
  return {
    fileName: input.fileName,
    sheetName: input.sheetName,
    sheetRow: input.sheetRow,
    vendorName: input.cell('SUNAME'),
    productNumber: input.cell('NUMBER'),
    englishDescription,
    frenchDescription,
    reasons: pipeReasons(englishDescription, frenchDescription),
  };
}

function hasPipeInDescription(row: FlaggedVendorItemListRow): boolean {
  return row.reasons.length > 0;
}

export function analyzeVendorItemList(
  workbook: WorkBook,
  fileName: string,
): VendorItemListAnalysis | null {
  const scanned = scanCatalogWorkbook({
    workbook,
    fileName,
    requiredHeaders: VENDOR_ITEM_LIST_HEADERS,
    productHeader: 'NUMBER',
    toFlagged: toFlaggedVendorItemList,
  });
  if (!scanned) return null;
  return {
    rowsScanned: scanned.rowsScanned,
    flagged: scanned.flagged.filter(hasPipeInDescription),
  };
}
